import { htmlEntities } from "../utils";

class Messages {
    constructor(user, engine, inits, pkg, config, game, react) {
        this.user = user;
        this.engine = engine;
        this.inits = inits;
        this.pkg = pkg;
        this.config = config;
        this.game = game;
        this.react = react;

        this.dictionaryClient = {
            [this.pkg.clientPacketID.getMyCharacter]: this.getMyCharacter,
            [this.pkg.clientPacketID.getCharacter]: this.getCharacter,
            [this.pkg.clientPacketID.changeRopa]: this.changeRopa,
            [this.pkg.clientPacketID.changeHelmet]: this.changeHelmet,
            [this.pkg.clientPacketID.changeWeapon]: this.changeWeapon,
            [this.pkg.clientPacketID.changeArrow]: this.changeArrow,
            [this.pkg.clientPacketID.actPosition]: this.actPosition,
            [this.pkg.clientPacketID.changeHeading]: this.changeHeading,
            [this.pkg.clientPacketID.deleteCharacter]: this.deleteCharacter,
            [this.pkg.clientPacketID.dialog]: this.dialog,
            [this.pkg.clientPacketID.console]: this.dataConsole,
            [this.pkg.clientPacketID.pong]: this.pong,
            [this.pkg.clientPacketID.animFX]: this.animFX,
            [this.pkg.clientPacketID.inmo]: this.inmo,
            [this.pkg.clientPacketID.updateHP]: this.updateHP,
            [this.pkg.clientPacketID.updateMaxHP]: this.updateMaxHP,
            [this.pkg.clientPacketID.updateMana]: this.updateMana,
            [this.pkg.clientPacketID.telepMe]: this.telepMe,
            [this.pkg.clientPacketID.actOnline]: this.actOnline,
            [this.pkg.clientPacketID.consoleOnline]: this.consoleOnline,
            [this.pkg.clientPacketID.actPositionServer]: this.actPositionServer,
            [this.pkg.clientPacketID.actExp]: this.actExp,
            [this.pkg.clientPacketID.actMyLevel]: this.actMyLevel,
            [this.pkg.clientPacketID.actGold]: this.actGold,
            [this.pkg.clientPacketID.actColorName]: this.actColorName,
            [this.pkg.clientPacketID.error]: this.error,
            [this.pkg.clientPacketID.changeName]: this.changeName,
            [this.pkg.clientPacketID.changeShield]: this.changeShield,
            [this.pkg.clientPacketID.getNpc]: this.getNpc,
            [this.pkg.clientPacketID.changeShield]: this.changeShield,
            [this.pkg.clientPacketID.putBodyAndHeadDead]: this
                .putBodyAndHeadDead,
            [this.pkg.clientPacketID.revivirUsuario]: this.revivirUsuario,
            [this.pkg.clientPacketID.quitarUserInvItem]: this.quitarUserInvItem,
            [this.pkg.clientPacketID.renderItem]: this.renderItem,
            [this.pkg.clientPacketID.deleteItem]: this.deleteItem,
            [this.pkg.clientPacketID.agregarUserInvItem]: this
                .agregarUserInvItem,
            [this.pkg.clientPacketID.blockMap]: this.blockMap,
            [this.pkg.clientPacketID.changeObjIndex]: this.changeObjIndex,
            [this.pkg.clientPacketID.openTrade]: this.openTrade,
            [this.pkg.clientPacketID.aprenderSpell]: this.aprenderSpell,
            [this.pkg.clientPacketID.closeForce]: this.closeForce,
            [this.pkg.clientPacketID.nameMap]: this.nameMap,
            [this.pkg.clientPacketID.changeBody]: this.changeBody,
            [this.pkg.clientPacketID.navegando]: this.navegando,
            [this.pkg.clientPacketID.updateAgilidad]: this.updateAgilidad,
            [this.pkg.clientPacketID.updateFuerza]: this.updateFuerza,
            [this.pkg.clientPacketID.playSound]: this.playSound,
            [this.pkg.clientPacketID.fishingState]: this.fishingState,
            [this.pkg.clientPacketID.miningState]: this.miningState,
            [this.pkg.clientPacketID.talarState]: this.talarState,
            [this.pkg.clientPacketID.aceleracionState]: this.aceleracionState,
            [this.pkg.clientPacketID.radioTrack]: this.radioTrack,
            [this.pkg.clientPacketID.radioAutoContinue]: this.radioAutoContinue,
            [this.pkg.clientPacketID.setInvisible]: this.setInvisible,
            [this.pkg.clientPacketID.sombraOscura]: this.sombraOscura,
            [this.pkg.clientPacketID.furiaState]: this.furiaState,
            [this.pkg.clientPacketID.ojoDemiurgo]: this.ojoDemiurgo,
            [this.pkg.clientPacketID.sigiloAtidorfa]: this.sigiloAtidorfa,
            [this.pkg.clientPacketID.openPerdon]: this.openPerdon,
            [this.pkg.clientPacketID.openCriminalConfirm]: this
                .openCriminalConfirm,
            [this.pkg.clientPacketID.openMagiaUpgrade]: this.openMagiaUpgrade,
            [this.pkg.clientPacketID.npcInspect]: this.npcInspect,
            [this.pkg.clientPacketID.userInspect]: this.userInspect,
            [this.pkg.clientPacketID.openHerreria]: this.openHerreria,
            [this.pkg.clientPacketID.updateNpcHp]: this.updateNpcHp,
            [this.pkg.clientPacketID.npcStatus]: this.npcStatus,
            [this.pkg.clientPacketID.openBank]: this.openBank,
            [this.pkg.clientPacketID.bankUpdate]: this.bankUpdate,
            [this.pkg.clientPacketID.partyState]: this.partyState,
            [this.pkg.clientPacketID.partyInviteReceived]: this.partyInviteReceived,
            [this.pkg.clientPacketID.petBuff]: this.petBuff,
            [this.pkg.clientPacketID.invisibilityBlip]: this.invisibilityBlip,
            [this.pkg.clientPacketID.clanInfo]: this.clanInfo,
            [this.pkg.clientPacketID.clanMembersPos]: this.clanMembersPos,
            [this.pkg.clientPacketID.clanList]: this.clanList,
            [this.pkg.clientPacketID.openFerry]: this.openFerry,
            [this.pkg.clientPacketID.globalList]: this.globalList
        };
    }

    // Lazy map loading (ver inits.ensureMapLoaded): durante una map
    // transition (getMyCharacter inicial + telepMe), suspendemos el
    // procesamiento de WS messages hasta que el mapa esté cargado.
    // Sin esto, packets que siguen al telepMe (setNewAreas, renderItem,
    // sendCharacter, etc.) intentarían acceder a inits.mapa[N] aún no
    // cargado y crashearían.
    //
    // Los browsers ya nos dan una ArrayBuffer fresca por cada onmessage,
    // así que guardar res.data en el queue es seguro (no se reusa).
    _messageQueueSuspended = false;
    _messageQueue = [];

    suspendMessageQueue = () => {
        this._messageQueueSuspended = true;
    };

    resumeMessageQueue = () => {
        this._messageQueueSuspended = false;
        const q = this._messageQueue;
        this._messageQueue = [];
        for (const data of q) {
            // Process inline — si alguno suspende de vuelta (telepMe
            // anidado en el burst), suspendMessageQueue setea el flag y
            // los packets RESTANTES de esta iteración se re-queuean.
            // Como nuestro for-of itera sobre el snapshot original,
            // necesitamos chequear el flag y abortar para no perder orden.
            if (this._messageQueueSuspended) {
                // Re-queue lo que queda — JS FIFO preservado.
                this._messageQueue = q.slice(q.indexOf(data));
                break;
            }
            this.pkg.setData(data);
            const id = this.pkg.getPackageID();
            const handler = this.dictionaryClient[id];
            if (typeof handler === "function") handler();
        }
    };

    connectionMessages = res => {
        if (this._messageQueueSuspended) {
            this._messageQueue.push(res.data);
            return;
        }

        this.pkg.setData(res.data);

        const packageID = this.pkg.getPackageID();

        const handler = this.dictionaryClient[packageID];
        if (typeof handler !== "function") {
            // Defensive — antes esto crasheaba el cliente entero. Ahora
            // logueamos y seguimos. Si pasa, es síntoma de:
            //  (a) packetID nuevo del server sin handler en cliente
            //  (b) wire desync (algún writeX/getX en server vs cliente
            //      no matchea bytes)
            console.warn(
                "[WS] packetID sin handler:",
                packageID,
                "data length:",
                res.data && res.data.byteLength
            );
            return;
        }
        handler();
    };

    getMyCharacter = () => {
        // Ticket #227: ids u32. Antes era getDouble + parseInt
        // por seguridad. Con getInt el parseInt ya no hace falta.
        this.user.id = this.pkg.getInt();
        this.user.nameCharacter = this.pkg.getString();
        this.user.idClase = this.pkg.getByte();
        this.config.mapNumber = this.pkg.getShort();
        // Notificar al engine de música — primer mapa del char post-login.
        try {
            const musicEngine = require("../music").default;
            musicEngine.setMap(this.config.mapNumber);
        } catch (e) {}
        // La Guarida del Bardo: garantizar que la radio arranque OFF
        // en cada login. Si el módulo singleton sobrevive de una sesión
        // previa (SPA navigation), su estado quedaría stale. Reset
        // silencia al player y restaura la música del mapa.
        try {
            const radioEngine = require("../radio").default;
            radioEngine.resetForLogin();
        } catch (e) {}
        this.user.pos.x = this.pkg.getByte();
        this.user.pos.y = this.pkg.getByte();
        this.user.idHead = this.pkg.getShort();
        this.user.idHelmet = this.pkg.getShort();
        this.user.idWeapon = this.pkg.getShort();
        this.user.idShield = this.pkg.getShort();
        this.user.idBody = this.pkg.getShort();
        this.user.hp = this.pkg.getShort();
        this.user.maxHp = this.pkg.getShort();
        this.user.mana = this.pkg.getShort();
        this.user.maxMana = this.pkg.getShort();
        this.user.privileges = this.pkg.getByte();
        this.user.exp = this.pkg.getDouble();
        this.user.expNextLevel = this.pkg.getDouble();
        this.user.level = this.pkg.getByte();
        this.user.gold = this.pkg.getInt();
        this.user.heading = this.pkg.getByte();
        this.user.inmovilizado = this.pkg.getByte();
        this.user.zonaSegura = this.pkg.getByte();
        this.user.color = this.pkg.getString();
        this.user.clan = this.pkg.getString();
        this.user.navegando = this.pkg.getByte();

        this.user.attrAgilidad = this.pkg.getByte();
        this.user.attrFuerza = this.pkg.getByte();

        // CRIT-27: reset items/spells antes del poblado. Sin esto, en
        // reconnect (WS drop + handshake nuevo), getMyCharacter agrega
        // las entries del server pero NO borra las del state anterior.
        // Si en la sesión vieja tenías un item en slot 5 y al volver no
        // lo tenés, el slot 5 quedaba con el item viejo "fantasma".
        this.user.items = {};
        this.user.spells = {};

        const itemsLength = this.pkg.getByte();

        for (let i = 0; i < itemsLength; i++) {
            const idPos = this.pkg.getByte();
            // Ticket #228: server ya no manda el name del item.
            // Lookup en inits.objs (catalog cliente-side).
            const idItem = this.pkg.getInt();
            const objCatalog = this.inits.objs[idItem];

            this.user.items[idPos] = {
                idItem,
                nameItem: (objCatalog && objCatalog.name) || "",
                equipped: this.pkg.getByte(),
                grhIndex: this.pkg.getShort(),
                cant: this.pkg.getShort(),
                gold: this.pkg.getInt(),
                objType: this.pkg.getByte(),
                validUser: this.pkg.getByte(),
                info: this.pkg.getString()
            };
        }

        if (this.user.maxMana > 0) {
            const spellsLength = this.pkg.getByte();

            for (let i = 0; i < spellsLength; i++) {
                const idPos = this.pkg.getByte();

                this.user.spells[idPos] = {
                    idSpell: this.pkg.getShort(),
                    name: this.pkg.getString(),
                    manaRequired: this.pkg.getShort()
                };
            }

            // spellOrder (array de idSpell) y favoriteSpells (legacy, ya
            // no usado — la feature fue removida). Parseamos ambos para
            // mantener byte-alignment con el packet del server, pero solo
            // spellOrder se consume.
            const orderLen = this.pkg.getByte();
            const spellOrder = [];
            for (let i = 0; i < orderLen; i++) {
                spellOrder.push(this.pkg.getShort());
            }
            this.user.spellOrder = spellOrder;

            const favLen = this.pkg.getByte();
            for (let i = 0; i < favLen; i++) {
                this.pkg.getShort(); // descartado
            }
        }

        // v2026-06-26: skill points por char. Persiste lastSeenLevel
        // bajo `skillPointsLastLevel:<nameCharacter>`. Si el char nunca
        // tuvo este sistema (lastSeen=null), inicializa con 10 + (lvl-1)*5
        // — fórmula AO Libre canónica. Si lastSeen < lvl actual, suma el
        // delta (puede pasar si el char subió levels offline o el sistema
        // se rolló-out con el char en lvl alto).
        try {
            var charKey = this.user.nameCharacter || "default";
            var lvlKey = "skillPointsLastLevel:" + charKey;
            var lastSeenStr = localStorage.getItem(lvlKey);
            var currentLvl = this.user.level || 1;
            var currentPts = this.react.state.skillPoints || 0;
            if (lastSeenStr === null) {
                // Primera vez con el sistema para este char — backfill.
                var initialPts = 10 + (currentLvl - 1) * 5;
                this.react.setState({ skillPoints: initialPts });
                localStorage.setItem("skillPoints", String(initialPts));
                localStorage.setItem(lvlKey, String(currentLvl));
            } else {
                var lastSeen = parseInt(lastSeenStr, 10) || 1;
                if (currentLvl > lastSeen) {
                    var delta = (currentLvl - lastSeen) * 5;
                    var newPts = currentPts + delta;
                    this.react.setState({ skillPoints: newPts });
                    localStorage.setItem("skillPoints", String(newPts));
                    localStorage.setItem(lvlKey, String(currentLvl));
                }
            }
        } catch (e) {}

        this.react.setState({
            user: this.user,
            spellOrder: this.user.spellOrder || []
        });

        let tmpPersonaje = JSON.parse(JSON.stringify(this.user));
        tmpPersonaje.moveOffsetX = 0;
        tmpPersonaje.moveOffsetY = 0;
        tmpPersonaje.fxId = 0;
        tmpPersonaje.frameFxCounter = 0;
        tmpPersonaje.scrollDirectionX = 0;
        tmpPersonaje.scrollDirectionY = 0;
        tmpPersonaje.moving = 0;
        tmpPersonaje.frameCounter = 0;
        tmpPersonaje.frameCounterWeapon = 0;
        tmpPersonaje.color = this.user.color;
        tmpPersonaje.clan = this.user.clan;

        this.engine.setPersonaje(tmpPersonaje);

        // Lazy map loading: en lugar de asumir que mapa[mapNumber] está
        // pre-cargado (legacy 290 fetches al boot), ahora fetcheamos
        // on-demand. Suspendemos el queue de WS hasta que el mapa cargue
        // — setNewAreas + renderItem + sendCharacter llegan en ráfaga
        // post-getMyCharacter y crashearían sin la data del mapa.
        //
        // awaitRing1=true: en login esperamos a que los vecinos del
        // mapa de spawn también estén cargados antes de soltar el
        // engine. Asegura que la PRIMERA transición desde el spawn
        // sea garantizada instant (sin blip de fetch).
        this.suspendMessageQueue();
        this.inits
            .loadCurrentMapAndPrefetch(this.config.mapNumber, true)
            .then(() => {
                this.engine.setMapData(
                    this.config.mapNumber,
                    this.user.pos,
                    this.user.id
                );

                if (!this.config.engineStart) {
                    this.engine.loop();
                    this.config.engineStart = true;
                }

                this.engine.renderBackground(0, 0);
                this.resumeMessageQueue();
            })
            .catch(err => {
                console.error("[lazy-map] getMyCharacter load failed:", err);
                this.resumeMessageQueue();
            });
    };

    getCharacter = () => {
        var id = this.pkg.getInt();

        var tmpPersonaje = {};

        tmpPersonaje.id = id;
        tmpPersonaje.nameCharacter = this.pkg.getString();
        tmpPersonaje.idClase = this.pkg.getByte();
        tmpPersonaje.pos = {
            x: 0,
            y: 0
        };
        tmpPersonaje.map = this.pkg.getShort();
        tmpPersonaje.pos.x = this.pkg.getByte();
        tmpPersonaje.pos.y = this.pkg.getByte();
        tmpPersonaje.idHead = this.pkg.getShort();
        tmpPersonaje.idHelmet = this.pkg.getShort();
        tmpPersonaje.idWeapon = this.pkg.getShort();
        tmpPersonaje.idShield = this.pkg.getShort();
        tmpPersonaje.idBody = this.pkg.getShort();
        tmpPersonaje.isNpc = false;
        tmpPersonaje.privileges = this.pkg.getByte();
        tmpPersonaje.heading = this.pkg.getByte();
        tmpPersonaje.color = this.pkg.getString();
        tmpPersonaje.clan = this.pkg.getString();
        // v2026-06-22: sombraOscura — Sombra Oscura de Morgolock (#49).
        // Si llega 1, el char entró al viewport ya en sigilo (típicamente
        // post-teleport o nuevo viewer entrando al área). Set del flag
        // hace que drawChar skipee el render para chars de otros, mute
        // pasos, etc.
        tmpPersonaje.sombraOscura = this.pkg.getByte();
        // v2026-06-25: invisible — Invisibilidad clásica (#14). Mismo
        // patrón que sombraOscura. NO seteamos los fade fields aquí —
        // el char debe arrancar invisible from frame 1 (no replay de
        // la animación de fade-out, que ya ocurrió "fuera de cámara").
        tmpPersonaje.invisible = this.pkg.getByte();
        // v2026-06-25: El Ojo del Demiurgo (#43). Mismo patrón.
        tmpPersonaje.ojoDemiurgo = this.pkg.getByte();
        // v2026-06-25: Sigilo de Atidorfa (#51). Mismo patrón.
        tmpPersonaje.sigiloAtidorfa = this.pkg.getByte();

        tmpPersonaje.moveOffsetX = 0;
        tmpPersonaje.moveOffsetY = 0;
        tmpPersonaje.fxId = 0;
        tmpPersonaje.frameFxCounter = 0;
        tmpPersonaje.scrollDirectionX = 0;
        tmpPersonaje.scrollDirectionY = 0;
        tmpPersonaje.moving = 0;
        tmpPersonaje.frameCounter = 0;

        this.engine.setPersonaje(tmpPersonaje);

        // Ticket #312: si el packet getCharacter es del PROPIO user (caso
        // típico: /gm toggle, /enlistar, hacerCriminal — el server hace
        // re-broadcast del char a viewport incluido self), sincronizar
        // también `this.user.color/clan/...` que son la fuente de verdad
        // del state del componente play (factionClassSuffix lee de ahí).
        // Sin esto el HUD/minimapa quedaba con valores stale (verde GM
        // aunque el server ya nos dijo que el color cambió).
        if (this.user && id === this.user.id) {
            this.user.color = tmpPersonaje.color;
            this.user.clan = tmpPersonaje.clan;
            // Trigger re-render del HUD/minimapa para que la new color
            // class del player dot tome efecto. _hudTick es un primitivo
            // distinto cada vez — garantiza setState sin bail-out de
            // React. Ver ticket #312.
            if (this.react && typeof this.react.setState === "function") {
                this.react.setState({
                    user: this.user,
                    _hudTick: Date.now()
                });
            }
        }

        this.engine.setMapData(
            this.config.mapNumber,
            tmpPersonaje.pos,
            tmpPersonaje.id
        );
    };

    getNpc = () => {
        const id = this.pkg.getInt();

        let tmpPersonaje = {};

        tmpPersonaje.id = id;
        tmpPersonaje.nameCharacter = this.pkg.getString();
        tmpPersonaje.idClase = this.pkg.getByte();
        tmpPersonaje.pos = {
            x: 0,
            y: 0
        };
        tmpPersonaje.map = this.pkg.getShort();
        tmpPersonaje.pos.x = this.pkg.getByte();
        tmpPersonaje.pos.y = this.pkg.getByte();
        tmpPersonaje.idHead = this.pkg.getShort();
        tmpPersonaje.idHelmet = this.pkg.getShort();
        tmpPersonaje.idWeapon = this.pkg.getShort();
        tmpPersonaje.idShield = this.pkg.getShort();
        tmpPersonaje.idBody = this.pkg.getShort();
        tmpPersonaje.isNpc = true;
        tmpPersonaje.heading = this.pkg.getByte();
        tmpPersonaje.color = this.pkg.getString();
        tmpPersonaje.clan = this.pkg.getString();
        // npcType — para condicionar context menu (ej. Gobernador=11
        // habilita "Hogar"). Default 0 si el server no lo manda.
        tmpPersonaje.npcType = this.pkg.getByte();
        // Ticket #298: tint del sprite. "" = sin filter (default). Otros:
        // "white" (Dragón Blanco), "blue", "green", "red". Aplicado en
        // charRender vía ctx.filter durante drawImage del body.
        tmpPersonaje.tint = this.pkg.getString() || "";

        tmpPersonaje.moveOffsetX = 0;
        tmpPersonaje.moveOffsetY = 0;
        tmpPersonaje.fxId = 0;
        tmpPersonaje.frameFxCounter = 0;
        tmpPersonaje.scrollDirectionX = 0;
        tmpPersonaje.scrollDirectionY = 0;
        tmpPersonaje.moving = 0;
        tmpPersonaje.frameCounter = 0;

        this.engine.setPersonaje(tmpPersonaje);

        this.engine.setMapData(
            this.config.mapNumber,
            tmpPersonaje.pos,
            tmpPersonaje.id
        );
    };

    changeName = () => {
        const id = this.pkg.getInt();

        this.engine.setAttrPersonaje(id, "nameCharacter", this.pkg.getString());
    };

    changeRopa = () => {
        const id = this.pkg.getInt();
        const grhRopa = this.pkg.getShort();
        const idPos = this.pkg.getByte();

        if (id == this.user.id) {
            for (let idIndexPos in this.user.items) {
                const item = this.user.items[idIndexPos];

                if (item.objType == this.config.objType.armaduras) {
                    if (idIndexPos != idPos) {
                        this.user.items[idIndexPos].equipped = false;
                    }
                }
            }

            const item = this.user.items[idPos];

            this.user.items[idPos].equipped = !item.equipped;

            this.react.setState({
                user: this.user
            });
        }

        this.engine.setAttrPersonaje(id, "idBody", grhRopa);
    };

    changeHelmet = () => {
        const id = this.pkg.getInt();
        const grhHelmet = this.pkg.getShort();

        const idPos = this.pkg.getByte();

        if (id == this.user.id) {
            for (let idIndexPos in this.user.items) {
                const item = this.user.items[idIndexPos];

                if (item.objType == this.config.objType.cascos) {
                    if (idIndexPos != idPos) {
                        this.user.items[idIndexPos].equipped = false;
                    }
                }
            }

            const item = this.user.items[idPos];

            this.user.items[idPos].equipped = !item.equipped;

            this.react.setState({
                user: this.user
            });
        }

        this.engine.setAttrPersonaje(id, "idHelmet", grhHelmet);
    };

    changeWeapon = () => {
        const id = this.pkg.getInt();
        const grhWeapon = this.pkg.getShort();

        const idPos = this.pkg.getByte();

        if (id == this.user.id) {
            // objTypes que comparten el slot de arma: armas (2) + las
            // herramientas caña (37), pico (38), hacha (39) y martillo (40).
            // Al equipar cualquiera, se desequipan todas las demás. Sin
            // incluir la herramienta acá, equipar un arma sobre ella dejaba
            // la "E" colgada (ambas parecían equipadas).
            const WEAPON_SLOT_TYPES = [2, 37, 38, 39, 40];
            for (let idIndexPos in this.user.items) {
                const item = this.user.items[idIndexPos];
                // Defense: el inv puede tener entries inválidas (idItem=0
                // por race con quitarUserInvItem, o slots fantasma de
                // bugs previos). Skip si item es null/undefined.
                if (!item) continue;

                if (WEAPON_SLOT_TYPES.includes(item.objType)) {
                    if (idIndexPos != idPos) {
                        this.user.items[idIndexPos].equipped = false;
                    }
                }
            }

            // Defense: si el slot apuntado ya no existe localmente
            // (race con quitarUserInvItem, o packet stale), skipear el
            // toggle de equipped — el visual igual se updatea via
            // setAttrPersonaje(idWeapon) abajo. Sin este guard, crashea
            // con TypeError y el ws cierra.
            const item = this.user.items[idPos];
            if (item) {
                this.user.items[idPos].equipped = !item.equipped;
                this.react.setState({
                    user: this.user
                });
            }
        }

        this.engine.setAttrPersonaje(id, "idWeapon", grhWeapon);
    };

    changeArrow = () => {
        const id = this.pkg.getInt();
        const idPos = this.pkg.getByte();

        if (id == this.user.id) {
            for (let idIndexPos in this.user.items) {
                const item = this.user.items[idIndexPos];

                if (item.objType == this.config.objType.flechas) {
                    if (idIndexPos != idPos) {
                        this.user.items[idIndexPos].equipped = false;
                    }
                }
            }

            const item = this.user.items[idPos];

            this.user.items[idPos].equipped = !item.equipped;

            this.react.setState({
                user: this.user
            });
        }
    };

    changeShield = () => {
        const id = this.pkg.getInt();
        const grhShield = this.pkg.getShort();

        const idPos = this.pkg.getByte();

        if (id == this.user.id) {
            for (let idIndexPos in this.user.items) {
                const item = this.user.items[idIndexPos];

                if (item.objType == this.config.objType.escudos) {
                    if (idIndexPos != idPos) {
                        this.user.items[idIndexPos].equipped = false;
                    }
                }
            }

            const item = this.user.items[idPos];

            this.user.items[idPos].equipped = !item.equipped;

            this.react.setState({
                user: this.user
            });
        }

        this.engine.setAttrPersonaje(id, "idShield", grhShield);
    };

    actPosition = () => {
        const id = this.pkg.getInt();
        const x = this.pkg.getByte();
        const y = this.pkg.getByte();

        this.engine.moveCharByPos(id, x, y);
    };

    changeHeading = () => {
        const id = this.pkg.getInt();
        const heading = this.pkg.getByte();

        this.engine.setAttrPersonaje(id, "heading", heading);
    };

    dialog = () => {
        const id = this.pkg.getInt();
        const msg = this.pkg.getString();
        const haveName = this.pkg.getByte();
        let name = "";

        if (haveName) {
            name = this.pkg.getString();
        }

        const color = this.pkg.getString();
        const consoleFlag = this.pkg.getByte();
        // v2026-06-25: lifetime del dialog en décimas de segundo.
        // Default 20 = 2s, Invisibilidad 10 = 1s. Wall-clock based
        // (no frame-based) para que la duración sea idéntica entre
        // cliente caster y observers sin depender del fps del browser.
        const lifeTenths = this.pkg.getByte() || 20;
        const lifeMaxMs = lifeTenths * 100;
        // v2026-06-25 bypassStealth: si =1, el dialog se renderea aún
        // cuando el char está en sombraOscura. Solo se setea para las
        // palabras de Sombra Oscura (Mor'golok Khel Sombrium) — el resto
        // de palabras de un char en sombra quedan suprimidas para otros.
        const bypassStealth = this.pkg.getByte() === 1;

        // Ticket #301: el flotante en CAJA 1 (sobre el sprite del char,
        // canvas) usa un solo color para todo el mensaje. Si es chat de
        // GM (#419900 verde) o Mod, override a blanco — el nombre del char
        // arriba del sprite sigue verde porque viene de `personaje.color`
        // que es propiedad persistente del char (no del dialog). Coherente
        // con el chat console que solo destaca el [Name] en verde.
        const colorLower = typeof color === "string" ? color.toLowerCase() : "";
        const dialogColor = colorLower === "#419900" ? "white" : color;

        // Bubble flotante en CAJA 1 — siempre se crea (revertido #303
        // tras feedback: el user quería arreglar el badge del tab Chat, no
        // suprimir el flotante visual sobre el char).
        this.config.dialogs[id] = {
            msg: msg,
            color: dialogColor,
            // life sigue contando frames solo para el float upward (y).
            // La expiración la marca expiresAt (wall-clock), no life.
            life: 0,
            expiresAt: Date.now() + lifeMaxMs,
            bypassStealth: bypassStealth,
            y: 20
        };

        // Ticket #303 (re-interpretado): detectar si el dialog que llega
        // es del PROPIO user (whisper saliente que el server eco-back, o
        // mi propio chat GM). En esos casos, el writeConsole debe correr
        // pero SIN incrementar el badge del tab Chat — porque ya estoy
        // viendo lo que escribí; no es una notificación entrante.
        const isOwnDialog = !!(this.user && id === this.user.id);

        if (consoleFlag) {
            // writeConsole recibe el color ORIGINAL (verde si GM) — su
            // lógica de split [Name]/rest sabe cómo manejarlo. Pasamos
            // un 5to arg `skipBadge` = true para el propio dialog así el
            // tab Chat no cuenta mis whispers salientes/mi GM chat.
            this.game.writeConsole(
                "[" + name + "]  " + htmlEntities(msg),
                color,
                0,
                1,
                isOwnDialog
            );
        }

        // Ticket #302: capturar el sender de whispers entrantes para que
        // el comando /r pueda auto-completar con /w <senderName> ...
        // El whisper viene como dialog con color #DA6FD1. El packet lleva
        // `id = ws.id` del EMISOR — si el id es el mío, soy el emisor y
        // NO guardo (sino /r me respondería a mí mismo). Si el id es de
        // otro, soy el target y guardo su name.
        if (
            typeof color === "string" &&
            color.toLowerCase() === "#da6fd1" &&
            name &&
            this.user &&
            id !== this.user.id
        ) {
            this.react.setState({ lastWhisperFrom: name });
            // Ducking de música: susurro entrante.
            try {
                const musicEngine = require("../music").default;
                musicEngine.onWhisperReceived();
            } catch (e) {}
        }
    };

    dataConsole = () => {
        const msg = this.pkg.getString();
        const haveColor = this.pkg.getByte();

        let color = "";
        if (haveColor) {
            color = this.pkg.getString();
        }

        const bold = this.pkg.getByte();
        const italic = this.pkg.getByte();

        this.game.writeConsole(msg, color, bold, italic);
    };

    pong = () => {
        this.engine.ping = +Date.now() - this.config.pingStart;
    };

    animFX = () => {
        const id = this.pkg.getInt();
        const fxID = this.pkg.getShort();

        this.engine.setAttrPersonaje(id, "fxId", fxID);
    };

    playSound = () => {
        const idSound = this.pkg.getByte();

        if (idSound !== 0) {
            // Cargado lazy para evitar reference circular si lo ponemos al tope.
            const audioManager = require("../audio").default;
            audioManager.play(idSound);
        }
    };

    // Pesca (#325): server avisa estado pescando (1) / no (0). El engine
    // dibuja "Pescando..." bajo "Seguro" mientras esté en 1.
    fishingState = () => {
        const estado = this.pkg.getByte();
        this.engine.pescando = estado === 1;
    };

    // Minería (#326): ídem pesca. El engine dibuja "Minando..." bajo "Seguro".
    miningState = () => {
        const estado = this.pkg.getByte();
        this.engine.minando = estado === 1;
    };

    // Talado (#327): ídem pesca/minería. El engine dibuja "Talando..." bajo "Seguro".
    talarState = () => {
        const estado = this.pkg.getByte();
        this.engine.talando = estado === 1;
    };

    // Aceleración Arcana (spell #52): buff stackeable de velocidad.
    // Cada stack DUPLICA la velocidad anterior (exponencial 2^stack):
    //   stack 1 → 2×, stack 2 → 4×, stack 3 → 8×, stack 4 → 16×, stack 5 → 32×.
    // Al activarse guardamos originales UNA vez, luego cada nuevo stack
    // recomputa timeWalkMS/pixelsPerFrame desde los originales usando el
    // multiplicador actual — así no acumulamos error si el packet re-llega.
    aceleracionState = () => {
        const estado = this.pkg.getByte();
        const durationMs = this.pkg.getInt();
        const stack = this.pkg.getByte();
        if (estado === 1) {
            // Guardar originales solo la PRIMERA vez que el buff se activa.
            if (!this.engine.aceleracionOriginals) {
                this.engine.aceleracionOriginals = {
                    timeWalkMS: this.engine.config.timeWalkMS,
                    pixelsX: this.engine.scrollPixelsPerFrameX,
                    pixelsY: this.engine.scrollPixelsPerFrameY
                };
            }
            const speedMult = Math.pow(2, stack);   // 2, 4, 8, 16, 32
            const orig = this.engine.aceleracionOriginals;
            this.engine.config.timeWalkMS = orig.timeWalkMS / speedMult;
            this.engine.scrollPixelsPerFrameX = orig.pixelsX * speedMult;
            this.engine.scrollPixelsPerFrameY = orig.pixelsY * speedMult;
            this.react && this.react.setState({
                aceleracionActive: true,
                aceleracionExpiresAt: Date.now() + durationMs,
                aceleracionStack: stack
            });
        } else {
            if (this.engine.aceleracionOriginals) {
                this.engine.config.timeWalkMS = this.engine.aceleracionOriginals.timeWalkMS;
                this.engine.scrollPixelsPerFrameX = this.engine.aceleracionOriginals.pixelsX;
                this.engine.scrollPixelsPerFrameY = this.engine.aceleracionOriginals.pixelsY;
                this.engine.aceleracionOriginals = null;
            }
            this.react && this.react.setState({
                aceleracionActive: false,
                aceleracionExpiresAt: null,
                aceleracionStack: 0
            });
        }
    };

    // La Guarida del Bardo — server nos avisa el track actual (login
    // catch-up o GM cambió sintonía). videoId="" = radio silenciada.
    // El engine de radio decide si suena algo (según toggle personal).
    radioTrack = () => {
        const videoId = this.pkg.getString();
        // startedAt viene en MS epoch (writeDouble) — usar tal cual, sin
        // multiplicar por 1000.
        const startedAtMs = this.pkg.getDouble();
        const gmName = this.pkg.getString();
        try {
            const radioEngine = require("../radio").default;
            if (typeof window !== "undefined") {
                window.__radioDebugGame = this.game;
            }
            radioEngine.setCurrentTrack(
                videoId || null,
                startedAtMs,
                gmName || null
            );
        } catch (e) {
            console.warn("[radio] handler error:", e && e.message);
        }
        // Feedback en el chat solo cuando NO es el catch-up de login
        // (que llega con gmName vacío o con track ya-visto). Simple:
        // si hay gmName no vacío, es un anuncio (GM cambió sintonía).
        if (gmName) {
            if (videoId) {
                this.game.writeConsole(
                    "♫ " + gmName + " sintonizó una nueva canción en La Guarida del Bardo.",
                    "#c88a4a"
                );
                // Hint amistoso: si el user NO tiene la radio activada,
                // avisamos cómo escuchar. Solo la primera vez por sesión
                // que un GM cambia sintonía con la radio OFF — evita spam.
                try {
                    const radioEngine = require("../radio").default;
                    if (!radioEngine.isEnabled() && !this._radioHintShown) {
                        this._radioHintShown = true;
                        this.game.writeConsole(
                            "♫ Tipeá /radio para sintonizar y escuchar.",
                            "#888"
                        );
                    }
                } catch (e) {}
            } else {
                this.game.writeConsole(
                    "♫ La Guarida del Bardo entró en pausa (silencio).",
                    "#888"
                );
            }
        }
    };

    // La Guarida del Bardo — auto-continue: server dice "cola vacía,
    // cargá tu Mix personalizado con este seed". Cliente carga
    // list=RD<seed> (playlist Mix de YouTube) para seguir escuchando.
    // Sync se pierde acá — cada cliente escucha su recomendación.
    radioAutoContinue = () => {
        const seedVideoId = this.pkg.getString();
        try {
            const radioEngine = require("../radio").default;
            radioEngine.startAutoContinueMix(seedVideoId);
        } catch (e) {
            console.warn("[radio] autoContinue error:", e && e.message);
        }
        this.game.writeConsole(
            "♫ La Guarida del Bardo pasa a modo Mix personalizado — cada usuario escuchará su propia recomendación.",
            "#888"
        );
    };

    // Recibe notificación de cambio de invisibilidad para `idUser`.
    // estado=1 → invisible, estado=0 → visible. El short final es la
    // duración restante en ms (solo relevante cuando estado=1).
    // El render lee `personajes[id].invisible` y decide qué dibujar:
    //   - Si es uno mismo → semi-transparente + buff icon en la UI
    //   - Si es otro      → no se dibuja
    // === Sombra Oscura de Morgolock (#49) ===
    // Sistema independiente de setInvisible. Cliente:
    //   - Setea personaje.sombraOscura = estado (engine usa este flag al
    //     decidir si dibuja el char en renderChar — true = skip render)
    //   - Para self: agrega/quita el buff icon en la UI (clickeable para
    //     desactivar via requestDeactivateSombraOscura)
    //   - Audio: mute pasos (engine playSteps chequea this.user.sombraOscura
    //     en self + personaje.sombraOscura en otros)
    sombraOscura = () => {
        const idUser = this.pkg.getInt();
        const estado = this.pkg.getByte();
        // v2026-06-25: duration en segundos para countdown en buff icon.
        // 0 = infinito (self-cast). N > 0 = cast-on-other (típicamente 30s).
        const durationSeconds = this.pkg.getShort();
        const personaje = this.engine.personajes[idUser];
        if (personaje) {
            personaje.sombraOscura = estado;
        }
        if (this.user && this.user.id === idUser) {
            this.user.sombraOscura = estado;
            // Toggle buff icon en la UI — patrón inverso al setInvisible
            // que usa un timeout, este es persistent hasta server-clear.
            this.react &&
                this.react.setState({
                    sombraOscuraActive: !!estado,
                    sombraOscuraExpiresAt:
                        estado && durationSeconds > 0
                            ? Date.now() + durationSeconds * 1000
                            : null
                });
        }
    };

    // === Morgolock's Soul — modal premium Magia ===
    openMagiaUpgrade = () => {
        const cost = this.pkg.getInt();
        this.react &&
            this.react.setState({ magiaUpgradeModal: { cost } });
    };

    // === Sistema /PERDON ===
    // Cuando un criminal usa /PERDON cerca del Conde Aldebrando, server
    // calcula el costo (100k × ciudadanos muertos) y manda este packet
    // para que el cliente muestre el modal de confirmación.
    openPerdon = () => {
        const cost = this.pkg.getInt();
        const ciudadanosKilled = this.pkg.getInt();
        this.react &&
            this.react.setState({
                perdonModal: { cost, ciudadanosKilled }
            });
    };

    // /criminal (#328): abre el modal de confirmación para volverse Criminal.
    openCriminalConfirm = () => {
        this.react && this.react.setState({ criminalModal: true });
    };

    // === Sigilo de Atidorfa (#51) ===
    // Sombra Oscura mejorada. Cliente lo usa para suprimir:
    //   - Palabras del char (todas, incluso chat)
    //   - Sonido de pasos del char
    // (Pociones y meditación las suprime el server, no llegan al cliente.)
    sigiloAtidorfa = () => {
        const idUser = this.pkg.getInt();
        const estado = this.pkg.getByte();
        const durationSeconds = this.pkg.getShort();
        const personaje = this.engine.personajes[idUser];
        if (personaje) {
            personaje.sigiloAtidorfa = estado;
        }
        if (this.user && this.user.id === idUser) {
            this.user.sigiloAtidorfa = estado;
            this.react &&
                this.react.setState({
                    sigiloAtidorfaActive: !!estado,
                    sigiloAtidorfaExpiresAt:
                        estado && durationSeconds > 0
                            ? Date.now() + durationSeconds * 1000
                            : null
                });
        }
    };

    // === El Ojo del Demiurgo (#43) ===
    // Mismo patrón que sombraOscura. State change con duración opcional
    // (0 = ∞ self-cast, N > 0 = cast-on-other con countdown).
    ojoDemiurgo = () => {
        const idUser = this.pkg.getInt();
        const estado = this.pkg.getByte();
        const durationSeconds = this.pkg.getShort();
        const personaje = this.engine.personajes[idUser];
        if (personaje) {
            personaje.ojoDemiurgo = estado;
        }
        if (this.user && this.user.id === idUser) {
            this.user.ojoDemiurgo = estado;
            this.react &&
                this.react.setState({
                    ojoDemiurgoActive: !!estado,
                    ojoDemiurgoExpiresAt:
                        estado && durationSeconds > 0
                            ? Date.now() + durationSeconds * 1000
                            : null
                });
        }
    };

    // === Furia de Uhkrul (#50) ===
    // estado=1 → ambos attrs entran al rojo pulse (atributos al cap por
    // Furia). estado=0 → vuelven a su tinte normal según el attr. Solo
    // se manda al user objetivo.
    furiaState = () => {
        const estado = this.pkg.getByte();
        if (this.user) {
            this.user.furiaActive = !!estado;
        }
        this.react && this.react.setState({ furiaActive: !!estado });
    };

    setInvisible = () => {
        const idUser = this.pkg.getInt();
        const estado = this.pkg.getByte();
        const durationMs = this.pkg.getShort();
        const personaje = this.engine.personajes[idUser];
        if (personaje) {
            // Ticket #289 polish: fade-out al inicio de la invisibilidad.
            // 700ms es lo suficientemente perceptible para que el observer
            // note "se está desvaneciendo" sin frenar el cast. Mismo
            // sistema que el blip (engine.js consume `invisibilityFadeEnd`).
            if (estado && !personaje.invisible) {
                const now = Date.now();
                personaje.invisibilityFadeStart = now;
                personaje.invisibilityFadeEnd = now + 700;
            } else if (!estado) {
                // Clear el fade y el blip cuando se vuelve visible.
                personaje.invisibilityFadeStart = 0;
                personaje.invisibilityFadeEnd = 0;
                personaje.blipStart = 0;
                personaje.blipEnd = 0;
            }
            personaje.invisible = estado;
        }
        if (this.user && this.user.id === idUser) {
            this.user.invisible = estado;
            // Buff UI: cuando uno mismo se vuelve invisible, guardar el
            // timestamp de expiración para el countdown. Cuando se quita,
            // limpiar a null para que el buff desaparezca.
            this.react &&
                this.react.setState({
                    invisibilityExpiresAt: estado
                        ? Date.now() + (durationMs || 0)
                        : null
                });
        }
    };

    // Ticket #289: blip de invisibilidad. Server avisa que un user invisible
    // debe pintarse semi-visible durante `durationMs` con fade in/out. Solo
    // se aplica a OTROS users (yo mismo me veo en alpha siempre que estoy
    // invisible — el blip es para que OTROS me vean). Lo guardo como
    // timestamps en el personaje; el render del engine lee blipStart/End
    // y aplica el alpha animado por frame. Sin re-render forzado — el
    // render loop normal ya itera personajes en viewport.
    invisibilityBlip = () => {
        const idUser = this.pkg.getInt();
        const durationMs = this.pkg.getInt();
        const personaje = this.engine.personajes[idUser];
        if (!personaje) return;
        const now = Date.now();
        personaje.blipStart = now;
        personaje.blipEnd = now + durationMs;
    };

    inmo = () => {
        const inmovilizado = this.pkg.getByte();
        const pos = {
            x: this.pkg.getByte(),
            y: this.pkg.getByte()
        };

        this.user.inmovilizado = inmovilizado;

        this.engine.inmovilizado(pos);
    };

    updateHP = () => {
        const hp = this.pkg.getShort();

        this.user.hp = hp;

        this.react.setState({
            user: this.user
        });
    };

    updateMaxHP = () => {
        const hp = this.pkg.getShort();
        const maxHp = this.pkg.getShort();

        this.user.hp = hp;
        this.user.maxHp = maxHp;

        this.react.setState({
            user: this.user
        });
    };

    updateMana = () => {
        const mana = this.pkg.getShort();

        this.user.mana = mana;

        this.react.setState({
            user: this.user
        });
    };

    updateAgilidad = () => {
        const agilidad = this.pkg.getByte();
        const durationMs = this.pkg.getInt();

        this.user.attrAgilidad = agilidad;

        this.react.setState({
            user: this.user,
            celeridadBuffExpiresAt: durationMs > 0
                ? Date.now() + durationMs
                : null
        });
    };

    updateFuerza = () => {
        const fuerza = this.pkg.getByte();
        const durationMs = this.pkg.getInt();

        this.user.attrFuerza = fuerza;

        this.react.setState({
            user: this.user,
            fuerzaBuffExpiresAt: durationMs > 0
                ? Date.now() + durationMs
                : null
        });
    };

    // Ticket #258: spawn/despawn de pet en la barra de buffs. durationMs > 0
    // = spawn (agregar a activePetBuffs). durationMs = 0 = despawn (filtrar).
    // npcIndex sirve para que el render elija el ícono correcto del elemento.
    petBuff = () => {
        const idPet = this.pkg.getInt();
        const npcIndex = this.pkg.getShort();
        const durationMs = this.pkg.getInt();

        const prev = this.react.state.activePetBuffs || [];
        let next;
        if (durationMs > 0) {
            const existing = prev.find(p => p.id === idPet);
            // Ticket #280: si ya existe (re-broadcast o re-invocación con
            // mismo id), preservar el `mode` que el user pudo haber cambiado
            // localmente. Sino default "offensive" (ver game.summonPet).
            const entry = {
                id: idPet,
                npcIndex,
                expiresAt: Date.now() + durationMs,
                totalMs: durationMs,
                mode: (existing && existing.mode) || "offensive"
            };
            next = existing
                ? prev.map(p => (p.id === idPet ? entry : p))
                : [...prev, entry];
        } else {
            next = prev.filter(p => p.id !== idPet);
        }
        this.react.setState({ activePetBuffs: next });
    };

    deleteCharacter = () => {
        const id = this.pkg.getInt();

        this.engine.deletePersonaje(id);
    };

    telepMe = () => {
        const id = this.pkg.getInt();
        const numMap = this.pkg.getShort();
        const pos = {
            x: this.pkg.getByte(),
            y: this.pkg.getByte()
        };

        // Lazy map loading: si telep es al MISMO mapa (telep dentro
        // del mapa actual), no hace falta esperar — el mapa ya está
        // cargado. Esto cubre el caso común de /hogar y la mayoría de
        // los telep entre puntos del mismo mapa.
        if (this.config.mapNumber === numMap || this.inits.mapa[numMap]) {
            this.engine.respawnMe(id, numMap, pos.x, pos.y);
            return;
        }

        // Mapa nuevo no cargado — suspender queue de WS, await load,
        // después respawnMe. Los packets post-telepMe (setNewAreas,
        // renderItem, sendCharacter, sendNpc) se acumulan y drainamos
        // tras el respawn.
        //
        // awaitRing1=false: en telep durante el juego, los vecinos
        // del destino los prefetcheamos en background. El caso ideal
        // (prefetch del mapa anterior ya los cacheó) cubre el 90%+
        // de los telep; el 10% raro es un blip de ~200ms en la
        // próxima transición, no acá.
        this.suspendMessageQueue();
        this.inits
            .loadCurrentMapAndPrefetch(numMap, false)
            .then(() => {
                this.engine.respawnMe(id, numMap, pos.x, pos.y);
                this.resumeMessageQueue();
            })
            .catch(err => {
                console.error("[lazy-map] telepMe load failed:", err);
                // Sin mapa no podemos respawnear — drain de queue
                // igual (sino el cliente queda mudo).
                this.resumeMessageQueue();
            });
    };

    actOnline = () => {
        this.config.usersOnline = this.pkg.getShort();
    };

    consoleOnline = () => {};

    actPositionServer = () => {
        const pos = {
            x: this.pkg.getByte(),
            y: this.pkg.getByte()
        };

        const heading = this.pkg.getByte();

        this.engine.actPositionServer(pos, heading);
    };

    actExp = () => {
        const exp = this.pkg.getDouble();

        this.user.exp = exp;

        this.react.setState({
            user: this.user
        });
    };

    actMyLevel = () => {
        const exp = this.pkg.getDouble();
        const expNextLevel = this.pkg.getDouble();
        const lvl = this.pkg.getByte();
        const hp = this.pkg.getShort();
        const mana = this.pkg.getShort();

        // Bug original: usaba `this.user.lvl` (typo). La UI lee `user.level`
        // así que el nivel no actualizaba visualmente al subir.
        const prevLevel = this.user.level || 0;
        this.user.exp = exp;
        this.user.expNextLevel = expNextLevel;
        this.user.level = lvl;
        this.user.hp = hp;
        this.user.maxHp = hp;
        this.user.maxMana = mana;

        // Ducking de música — level up (subió, no bajó).
        if (lvl > prevLevel) {
            try {
                const musicEngine = require("../music").default;
                musicEngine.onLevelUp();
            } catch (e) {}
            // v2026-06-26: +5 puntos de skill por cada nivel ganado.
            // Persiste también `skillPointsLastLevel:<char>` para que el
            // backfill de getMyCharacter (si re-loguea) no re-otorgue.
            const levelsGained = lvl - prevLevel;
            const newSkillPoints =
                ((this.react.state.skillPoints) || 0) + levelsGained * 5;
            this.react.setState({ user: this.user, skillPoints: newSkillPoints });
            try {
                localStorage.setItem("skillPoints", String(newSkillPoints));
                const charKey = this.user.nameCharacter || "default";
                localStorage.setItem("skillPointsLastLevel:" + charKey, String(lvl));
            } catch (e) {}
            return;
        }

        this.react.setState({
            user: this.user
        });
    };

    actGold = () => {
        const gold = this.pkg.getInt();

        this.user.gold = gold;

        this.react.setState({
            user: this.user
        });
    };

    actColorName = () => {
        const id = this.pkg.getInt();
        const color = this.pkg.getString();

        this.engine.setAttrPersonaje(id, "color", color);

        // Ticket #312: si el packet es del PROPIO user (típico:
        // hacerCriminal por matar civil), sincronizar this.user.color
        // y forzar re-render del HUD para que el minimapa + full map +
        // factionClassSuffix reflejen el nuevo estado al toque.
        if (this.user && id === this.user.id) {
            this.user.color = color;
            if (this.react && typeof this.react.setState === "function") {
                this.react.setState({
                    user: this.user,
                    _hudTick: Date.now()
                });
            }
        }
    };

    error = () => {
        alert(this.pkg.getString());
    };

    putBodyAndHeadDead = () => {
        const id = this.pkg.getInt();
        const idHead = this.pkg.getShort();
        const idHelmet = this.pkg.getShort();
        const idWeapon = this.pkg.getShort();
        const idShield = this.pkg.getShort();
        const idBody = this.pkg.getShort();

        if (this.user.id == id) {
            for (let idIndexPos in this.user.items) {
                this.user.items[idIndexPos].equipped = 0;
            }
            // Ducking de música: el char propio murió.
            try {
                const musicEngine = require("../music").default;
                musicEngine.onPlayerDeath();
            } catch (e) {}
        }

        this.react.setState({
            user: this.user
        });

        this.engine.setAttrPersonaje(id, "idHead", idHead);
        this.engine.setAttrPersonaje(id, "idHelmet", idHelmet);
        this.engine.setAttrPersonaje(id, "idWeapon", idWeapon);
        this.engine.setAttrPersonaje(id, "idShield", idShield);
        this.engine.setAttrPersonaje(id, "idBody", idBody);
        this.engine.setAttrPersonaje(id, "muerto", true);
    };

    revivirUsuario = () => {
        const id = this.pkg.getInt();
        const idHead = this.pkg.getShort();
        const idBody = this.pkg.getShort();

        this.engine.setAttrPersonaje(id, "idHead", idHead);
        this.engine.setAttrPersonaje(id, "idBody", idBody);
        this.engine.setAttrPersonaje(id, "muerto", false);
    };

    quitarUserInvItem = () => {
        const { showModalTrade, trade } = this.react.state;

        const idUser = this.pkg.getInt();
        const idPos = this.pkg.getByte();
        const cant = this.pkg.getShort();

        const cantOld = this.user.items[idPos].cant;

        const newCant = cantOld - cant;

        if (newCant <= 0) {
            delete this.user.items[idPos];

            if (showModalTrade) {
                delete trade.itemsUser[idPos];
            }
        } else {
            this.user.items[idPos].cant = newCant;

            if (showModalTrade) {
                trade.itemsUser[idPos].cant = newCant;
            }
        }

        this.react.setState({
            user: this.user,
            trade: trade
        });
    };

    renderItem = () => {
        const idItem = this.pkg.getInt(),
            idMap = this.pkg.getShort(),
            posX = this.pkg.getByte(),
            posY = this.pkg.getByte();

        this.inits.mapa[idMap][posY][posX].o = {
            oi: idItem
        };

        // Ticket #225: mantener el cache de posiciones de items sync con
        // el .o de mapa. Si el cache aún no se inicializó para este mapa,
        // el primer scan lazy en updateItems lo encontrará via mapa[].o.
        this.engine._addItemPosition(idMap, posY, posX);

        // Ticket #237: ya no llamamos updateItems acá — el próximo frame
        // de renderScreen pinta el item automáticamente en foreground.
    };

    deleteItem = () => {
        const idMap = this.pkg.getShort(),
            posX = this.pkg.getByte(),
            posY = this.pkg.getByte();

        delete this.inits.mapa[idMap][posY][posX].o;

        // Ticket #225: ver renderItem.
        this.engine._removeItemPosition(idMap, posY, posX);

        // Ticket #237: ver renderItem.
    };

    agregarUserInvItem = () => {
        const { showModalTrade, trade } = this.react.state;

        const idPos = this.pkg.getByte();
        // Ticket #228: ver getMyCharacter.
        const idItem = this.pkg.getInt();
        const objCatalog = this.inits.objs[idItem];

        this.user.items[idPos] = {
            idItem,
            nameItem: (objCatalog && objCatalog.name) || "",
            equipped: this.pkg.getByte(),
            grhIndex: this.pkg.getShort(),
            cant: this.pkg.getShort(),
            gold: this.pkg.getInt(),
            objType: this.pkg.getByte(),
            validUser: this.pkg.getByte(),
            info: this.pkg.getString()
        };

        if (showModalTrade) {
            const item = this.user.items[idPos];

            trade.itemsUser[idPos] = {
                idPos: idPos,
                name: item.nameItem,
                cant: item.cant,
                info: item.info,
                gold: item.gold,
                imgItem: `/static/graficos/${
                    this.inits.graphics[item.grhIndex].numFile
                }.png`,
                validUser: item.validUser,
                equipped: item.equipped
            };
        }

        this.react.setState({
            user: this.user,
            trade: trade
        });
    };

    blockMap = () => {
        const idMap = this.pkg.getShort();
        const posX = this.pkg.getByte();
        const posY = this.pkg.getByte();
        const blocked = this.pkg.getByte();

        this.inits.mapa[idMap][posY][posX].b = blocked;
    };

    changeObjIndex = () => {
        const idMap = this.pkg.getShort();
        const posX = this.pkg.getByte();
        const posY = this.pkg.getByte();
        const objIndex = this.pkg.getShort();

        this.inits.mapa[idMap][posY][posX].o.oi = objIndex;
    };

    openTrade = () => {
        const { trade } = this.react.state;

        // Identidad del NPC (ticket #269) — leída ANTES del item count.
        // Render del modal usa npcName en el header y npcHead para el
        // portrait via inits.heads[idHead] → grhIndex → graphics sheet.
        trade.npcName = this.pkg.getString();
        trade.npcHead = this.pkg.getShort();

        let itemsLength = this.pkg.getByte();

        this.user.npcTrade = true;

        trade.itemsTrade = {};

        // Ticket #229: name resuelto cliente-side via inits.objs[idItem].
        for (let i = 0; i < itemsLength; i++) {
            const idItem = this.pkg.getInt();
            const objIndex = this.pkg.getShort();
            const cant = this.pkg.getShort();
            const gold = this.pkg.getInt();
            const itemValidUser = this.pkg.getByte();
            const info = this.pkg.getString();
            const objCatalog = this.inits.objs[idItem];

            trade.itemsTrade[i] = {
                idPos: i,
                name: (objCatalog && objCatalog.name) || "",
                info: info,
                cant: cant,
                // 2026-06-19: refactor de la convención de precios. Antes
                // dividíamos `gold / 2` porque el server mandaba el "valor
                // canónico" (precio_real × 2). Ahora `valor` en objs.json ES
                // el precio de compra real → mostramos raw.
                gold: gold,
                imgItem: `/static/graficos/${
                    this.inits.graphics[objIndex].numFile
                }.png`,
                validUser: itemValidUser
            };
        }

        trade.itemsUser = {};

        itemsLength = this.pkg.getByte();

        for (let i = 0; i < itemsLength; i++) {
            const idItem = this.pkg.getInt();
            const objIndexItemInv = this.pkg.getShort();
            const cantItemInv = this.pkg.getShort();
            const goldItemInv = this.pkg.getInt();
            const equippedItemInv = this.pkg.getByte();
            const idPos = this.pkg.getByte();
            const itemValidUserItemInv = this.pkg.getByte();
            const infoItemInv = this.pkg.getString();
            const objCatalog = this.inits.objs[idItem];

            trade.itemsUser[idPos] = {
                idPos: idPos,
                name: (objCatalog && objCatalog.name) || "",
                cant: cantItemInv,
                info: infoItemInv,
                gold: goldItemInv,
                imgItem: `/static/graficos/${
                    this.inits.graphics[objIndexItemInv].numFile
                }.png`,
                validUser: itemValidUserItemInv,
                equipped: equippedItemInv
            };
        }

        this.react.setState({
            showModalTrade: true,
            trade: trade
        });
    };

    aprenderSpell = () => {
        const idPos = this.pkg.getByte();
        const idSpell = this.pkg.getShort();
        const name = this.pkg.getString();
        const manaRequired = this.pkg.getShort();

        // Reasignamos `spells` a un objeto nuevo: React shallow-compara state
        // y si pasamos la misma referencia mutada puede no re-renderizar
        // partes que ya cachearon `state.user.spells`.
        this.user.spells = {
            ...this.user.spells,
            [idPos]: { idSpell, name, manaRequired }
        };

        this.react.setState({
            user: this.user
        });
    };

    closeForce = () => {
        this.config.varCloseForce = true;
        // CRIT-67: mostrar modal explicativo. Antes el cliente quedaba
        // con pantalla negra sin feedback cuando el server te kickeaba
        // (dupe login en otra pestaña, anti-cheat, telep corrupto).
        // El modal se renderea en play/index.js via state.showModalCloseForce.
        if (this.react && typeof this.react.setState === "function") {
            this.react.setState({ showModalCloseForce: true });
        }
    };

    nameMap = () => {
        const name = this.pkg.getString();

        this.react.setState({
            nameMap: name
        });
    };

    changeBody = () => {
        const id = this.pkg.getInt();

        this.engine.setAttrPersonaje(id, "idHead", this.pkg.getShort());
        this.engine.setAttrPersonaje(id, "idBody", this.pkg.getShort());
        this.engine.setAttrPersonaje(id, "idHelmet", this.pkg.getShort());
        this.engine.setAttrPersonaje(id, "idWeapon", this.pkg.getShort());
        this.engine.setAttrPersonaje(id, "idShield", this.pkg.getShort());
    };

    navegando = () => {
        this.user.navegando = this.pkg.getByte();

        this.react.setState({
            user: this.user
        });
    };

    // Respuesta del server al inspectNpc. Lleva nombre + sprite + stats
    // de combate + drops. Lo guardamos en state.npcInspect para que el
    // /play renderee el modal.
    npcInspect = () => {
        const name = this.pkg.getString();
        const idHead = this.pkg.getShort();
        const idBody = this.pkg.getShort();
        const hp = this.pkg.getShort();
        const maxHp = this.pkg.getShort();
        const minHit = this.pkg.getShort();
        const maxHit = this.pkg.getShort();
        const def = this.pkg.getShort();
        const poderAtaque = this.pkg.getShort();
        const poderEvasion = this.pkg.getShort();
        const exp = this.pkg.getInt();
        const gold = this.pkg.getInt();
        const desc = this.pkg.getString();
        const dropsLength = this.pkg.getByte();
        const drops = [];
        for (let i = 0; i < dropsLength; i++) {
            drops.push({
                idItem: this.pkg.getShort(),
                name: this.pkg.getString(),
                cant: this.pkg.getShort(),
                grhIndex: this.pkg.getShort(),
                // chanceBps en basis points (10000 = 100%). El render
                // divide /100 y formatea con menos decimales para los
                // % chicos (90% / 10% / 1% / 0.1% / 0.01%).
                chanceBps: this.pkg.getShort()
            });
        }
        // Ticket #298: tint para que el modal aplique filter CSS al body.
        const tint = this.pkg.getString() || "";
        // Bonus base por kill (15% solo). El render multiplica por 1..5 para
        // mostrar las variantes 15%/30%/45%/60%/75% según party size.
        const bonusKillExp = this.pkg.getInt();

        this.react.setState({
            npcInspect: {
                name,
                idHead,
                idBody,
                hp,
                maxHp,
                minHit,
                maxHit,
                def,
                poderAtaque,
                poderEvasion,
                exp,
                gold,
                desc,
                drops,
                tint,
                bonusKillExp
            }
        });
    };

    // Respuesta del server al inspectUser. Primer campo es el idUser del
    // target — si matchea con this.user.id, es self-inspect y va a
    // state.selfInspect; sino es other-player y va a state.userInspect.
    // Ambos modales pueden coexistir; el modal same-target se REEMPLAZA
    // in-place cuando cambia el target (cero nuevos modales apilados).
    userInspect = () => {
        const idUser = this.pkg.getInt();
        const name = this.pkg.getString();
        const level = this.pkg.getByte();
        const idClase = this.pkg.getByte();
        const idRaza = this.pkg.getByte();
        const hp = this.pkg.getShort();
        const maxHp = this.pkg.getShort();
        const mana = this.pkg.getShort();
        const maxMana = this.pkg.getShort();
        const idHead = this.pkg.getShort();
        const idBody = this.pkg.getShort();
        const idHelmet = this.pkg.getShort();
        const idWeapon = this.pkg.getShort();
        const idShield = this.pkg.getShort();
        const criminal = this.pkg.getByte();
        const clan = this.pkg.getString();
        const privileges = this.pkg.getByte();
        const ciudadanosMatados = this.pkg.getShort();
        const criminalesMatados = this.pkg.getShort();
        const usersMuertos = this.pkg.getShort();
        const npcsMuertos = this.pkg.getInt();
        const data = {
            idUser,
            name,
            level,
            idClase,
            idRaza,
            hp,
            maxHp,
            mana,
            maxMana,
            idHead,
            idBody,
            idHelmet,
            idWeapon,
            idShield,
            criminal: !!criminal,
            clan,
            privileges,
            ciudadanosMatados,
            criminalesMatados,
            usersMuertos,
            npcsMuertos
        };
        const isSelf =
            this.user && String(idUser) === String(this.user.id);
        this.react.setState(isSelf
            ? { selfInspect: data }
            : { userInspect: data });
    };

    // openHerreria (#329) — server manda el conteo de minerales de cada
    // metal (Hierro/Plata/Oro). Abre el modal si estaba cerrado, o lo
    // refresca in-place tras forjar. El cliente deriva cuántos lingotes
    // puede forjar (÷100).
    openHerreria = () => {
        const cantHierro = this.pkg.getInt();
        const cantPlata = this.pkg.getInt();
        const cantOro = this.pkg.getInt();
        this.react.setState({
            herreriaModal: { cantHierro, cantPlata, cantOro }
        });
    };

    // updateNpcHp — server avisa que el NPC `idNpc` tiene hp/maxHp X/Y
    // tras un damage del cliente local. Solo lo recibe el atacante (no
    // broadcast). Lo guardamos en engine.personajes[idNpc] + flag de
    // visibilidad con timestamp de auto-hide (8s sin updates → fade).
    // El render loop (engine.js) lo dibuja como una barra Atrium debajo
    // del nombre.
    updateNpcHp = () => {
        const idNpc = this.pkg.getInt();
        // getInt (u32) en vez de getShort (u16) — bug "2 líneas de vida"
        // del Golem de Arena (70k HP > 65535). Server cambió a writeInt
        // simultáneamente para mantener el wire en sync.
        const hp = this.pkg.getInt();
        const maxHp = this.pkg.getInt();
        const npc = this.engine && this.engine.personajes[idNpc];
        if (!npc) return;
        npc.hp = hp;
        npc.maxHp = maxHp;
        // healthBarUntil — timestamp futuro. Si Date.now() < esto, la
        // bar es visible. 8s después del último damage, se oculta solo.
        npc.healthBarUntil = Date.now() + 8000;
    };

    // npcStatus — server avisa que el NPC entró en paralizar (type=1)
    // o inmovilizar (type=2). Guardamos start + duration para que el
    // render loop (engine.js) compute el % restante en cada frame.
    npcStatus = () => {
        const idNpc = this.pkg.getInt();
        const typeStatus = this.pkg.getByte();
        const durationMs = this.pkg.getInt();
        const npc = this.engine && this.engine.personajes[idNpc];
        if (!npc) return;
        npc.statusType = typeStatus;
        npc.statusStart = Date.now();
        npc.statusDuration = durationMs;
    };

    // openBank — server manda snapshot completo del banco al hacer click
    // sobre un NPC Banquero. Junto va el inv del user por safety (idem
    // openTrade). Guardamos en state.modalBank y el render del /play
    // dispara el modal con dos grids (Banco | Inventario).
    openBank = () => {
        const bankCount = this.pkg.getByte();
        const itemsBank = {};

        // Ticket #229: name resuelto cliente-side via inits.objs[idItem].
        for (let i = 0; i < bankCount; i++) {
            const idPos = this.pkg.getByte();
            const idItem = this.pkg.getInt();
            const objIndex = this.pkg.getShort();
            const cant = this.pkg.getShort();
            const info = this.pkg.getString();
            const objCatalog = this.inits.objs[idItem];

            itemsBank[idPos] = {
                idPos,
                name: (objCatalog && objCatalog.name) || "",
                cant,
                info,
                imgItem: `/static/graficos/${
                    this.inits.graphics[objIndex].numFile
                }.png`
            };
        }

        // Consumimos el inv del packet pero NO lo usamos para popular el
        // modal — el modal lee this.user.items directamente. El parse
        // es solo para mantener el offset del buffer correcto (no podemos
        // saltearnos bytes). Si en el futuro hay desync inv-cliente vs
        // inv-server al abrir el banco, conviene usar lo del packet.
        const invCount = this.pkg.getByte();
        for (let i = 0; i < invCount; i++) {
            this.pkg.getByte(); // idPos
            this.pkg.getInt(); // idItem (#229)
            this.pkg.getShort(); // grhIndex
            this.pkg.getShort(); // cant
            this.pkg.getString(); // info
        }

        this.react.setState({
            showModalBank: true,
            modalBank: {
                itemsBank
            }
        });
    };

    // bankUpdate — server avisa que un slot del banco cambió (deposit /
    // withdraw). idItem=0 significa "slot vacío". Aplicamos el cambio
    // directo sobre state.modalBank.itemsBank y forzamos re-render.
    bankUpdate = () => {
        const idPos = this.pkg.getByte();
        const idItem = this.pkg.getShort();
        const grhIndex = this.pkg.getShort();
        const cant = this.pkg.getShort();
        // Ticket #228: name resuelto cliente-side desde inits.objs.
        const objCatalog = this.inits.objs[idItem];
        const name = (objCatalog && objCatalog.name) || "";

        const { modalBank } = this.react.state;
        if (!modalBank) return;

        // Reasigno itemsBank a un objeto nuevo (shallow-compare friendly).
        const itemsBank = { ...modalBank.itemsBank };

        if (!idItem || idItem === 0) {
            delete itemsBank[idPos];
        } else {
            itemsBank[idPos] = {
                idPos,
                name,
                cant,
                info: "",
                imgItem: `/static/graficos/${
                    this.inits.graphics[grhIndex].numFile
                }.png`
            };
        }

        this.react.setState({
            modalBank: {
                ...modalBank,
                itemsBank
            }
        });
    };

    // partyState — actualiza el estado de la party del char en el state
    // de React. inParty=0 limpia la party (kicked / left / disband).
    // inParty=1 trae la lista de miembros + flag si el RECEPTOR es leader.
    //
    // Ticket #218: agregamos 4 fields por miembro al wire format:
    // map (short), x (byte), y (byte), criminal (byte). Habilitan el
    // render de party en el mapa con color por facción + posición.
    partyState = () => {
        const inParty = this.pkg.getByte();
        if (!inParty) {
            this.react.setState({
                party: null
            });
            return;
        }
        // Ticket #336 polish: si vengo de NO estar en party (state.party
        // null) y ahora SÍ — abrir el panel del party automáticamente.
        // El user puede cerrarlo manualmente con el botón PARTY si quiere.
        // Solo se dispara en la transición join (no en cada broadcast
        // periódico de 1500ms que seguiría llegando con state.party != null).
        const wasInParty = !!(this.react.state && this.react.state.party);
        // Ticket #336 v4: wire version byte. Si el server crece el shape
        // del payload, el cliente lee el version primero y decide cómo
        // parsear. Hoy v4 es el formato corriente (color incluido).
        // Si llega un version desconocido (futuro), bail safely.
        const wireVer = this.pkg.getByte();
        if (wireVer !== 4) {
            console.warn("[partyState] versión wire desconocida:", wireVer);
            return;
        }
        const iAmLeader = !!this.pkg.getByte();
        const memberCount = this.pkg.getByte();
        const members = [];
        // Ticket #336: wire v3 — incluye connected, idRaza, idGenero,
        // hp/maxHp, mana/maxMana. Los disconnected vienen con flags en 0.
        for (let i = 0; i < memberCount; i++) {
            const connected = !!this.pkg.getByte();
            const name = this.pkg.getString();
            const level = this.pkg.getShort();
            const idClase = this.pkg.getByte();
            const idRaza = this.pkg.getByte();
            const idGenero = this.pkg.getByte();
            const isLeader = !!this.pkg.getByte();
            const privileges = this.pkg.getByte();
            const hp = this.pkg.getShort();
            const maxHp = this.pkg.getShort();
            const mana = this.pkg.getShort();
            const maxMana = this.pkg.getShort();
            const map = this.pkg.getShort();
            const x = this.pkg.getByte();
            const y = this.pkg.getByte();
            const criminal = !!this.pkg.getByte();
            // Ticket #336: color del nombre, computado server-side (login.js
            // + toggleGmEnabled). El cliente lo usa raw → match exacto con
            // el nombre del char in-world.
            const color = this.pkg.getString();
            members.push({
                connected,
                name,
                level,
                idClase,
                idRaza,
                idGenero,
                isLeader,
                privileges,
                hp,
                maxHp,
                mana,
                maxMana,
                map,
                x,
                y,
                criminal,
                color
            });
        }
        const stateUpdate = { party: { iAmLeader, members } };
        // Si acabás de entrar a la party (no estabas en una y ahora sí),
        // abrimos el panel automáticamente para que veas el state nuevo.
        if (!wasInParty) {
            stateUpdate.showPartyModal = true;
        }
        this.react.setState(stateUpdate);
    };

    // partyInviteReceived — abre modal pidiendo aceptar/rechazar la
    // invitación de la party de `inviterName`. El user contesta vía
    // chat command `/p aceptar` o `/p rechazar` (los botones del modal
    // mandan esos comandos via this.general.sendDialog).
    partyInviteReceived = () => {
        const inviterName = this.pkg.getString();
        this.react.setState({
            partyInvite: { inviterName, receivedAt: Date.now() }
        });
    };

    // Ticket #313: info del clan del user. Llega al login, al fundar,
    // unirse, salir, o on demand. Payload JSON serializado.
    clanInfo = () => {
        try {
            const raw = this.pkg.getString();
            const payload = JSON.parse(raw || "{}");
            this.react.setState({ clan: payload });
        } catch (e) {
            console.log("clanInfo parse error:", e && e.message);
        }
    };

    // Ticket #313: posiciones live de miembros del clan online. El
    // cliente filtra por mapa al renderear (full map muestra mapa abierto,
    // minimap solo del actual). Push periodic + on demand.
    clanMembersPos = () => {
        try {
            const raw = this.pkg.getString();
            const positions = JSON.parse(raw || "[]");
            this.react.setState({ clanMembersPos: positions });
        } catch (e) {
            console.log("clanMembersPos parse error:", e && e.message);
        }
    };

    // Lista global de chars PvE conectados — panel GLOBAL del BOX 5.
    // Payload JSON: [{name, level, idClase, idRaza, color}]. El cliente
    // solo lo pide cuando el user abre el panel.
    globalList = () => {
        try {
            const raw = this.pkg.getString();
            const list = JSON.parse(raw || "[]");
            this.react.setState({ globalList: list });
        } catch (e) {
            console.log("globalList parse error:", e && e.message);
        }
    };

    // Ticket #313 polish: lista de clanes disponibles para unirse.
    clanList = () => {
        try {
            const raw = this.pkg.getString();
            const list = JSON.parse(raw || "[]");
            this.react.setState({ clanList: list });
        } catch (e) {
            console.log("clanList parse error:", e && e.message);
        }
    };

    // Ticket #321: openFerry — el server le manda al cliente la lista
    // de destinos al hacer click sobre un Marinero. El cliente renderea
    // modal con botones; click → useFerry packet con idxRuta.
    openFerry = () => {
        const npcName = this.pkg.getString();
        const npcHead = this.pkg.getShort();
        const count = this.pkg.getByte();
        const routes = [];
        for (let i = 0; i < count; i++) {
            const destMap = this.pkg.getShort();
            const cost = this.pkg.getInt();
            const label = this.pkg.getString();
            routes.push({ destMap, cost, label });
        }
        this.react.setState({
            showFerryModal: true,
            ferry: { npcName, npcHead, routes }
        });
    };
}

export default Messages;
